import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Respuesta, TmmvNodo } from "../_models/shared/_index";
import { Suscripcion } from "../_models/configuracion-notificaciones/_index";
import { ErrorService } from "./error.service";

@Injectable()
export class SuscripcionService {
  private getSuscripcionesUrl =
    environment.rest + "/Suscripcion/GetSuscripcionesByCurrentUser";
  private editSuscripcionUrl =
    environment.rest + "/Suscripcion/EditSuscripcion";
  private createSuscripcionUrl =
    environment.rest + "/Suscripcion/CreateSuscripcion";
  private getArbolSegmentosPorNodosTmmUrl =
    environment.rest + "/Suscripcion/GetArbolSegmentosPorNodosTmm";
  private deleteSuscripcionUrl =
    environment.rest + "/Suscripcion/DeleteSuscripcion";
  private activarSuscripcionUrl =
    environment.rest + "/Suscripcion/ActivarSuscripcion";
  private getPlantillasDivModelUrl =
    environment.rest + "/Suscripcion/GetPlantillasDivModel";
  private getPlantillasDivModelSinCuerpoUrl =
    environment.rest + "/Suscripcion/GetPlantillasDivModelSinCuerpo";
  private getTiposInformacionUrl =
    environment.rest + "/Suscripcion/GetTiposInformacion";
  private getFullSegmentacionPorNodosSeleccionadosUrl =
    environment.rest + "/Suscripcion/GetFullSegmentacionPorNodosSeleccionados";
  private getFullSegmentacionUrl =
    environment.rest + "/Suscripcion/GetFullSegmentacion";
  private getFrecuenciasUrl = environment.rest + "/Suscripcion/GetFrecuencias";
  private getMercadosUrl = environment.rest + "/RsNews/GetMercados";

  private options = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
    withCredentials: true
  };
  headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(private http: HttpClient, private errorService: ErrorService) { }

  getArbolSegmentosPorNodosTmm(
    selectedNodosArbolTmm: TmmvNodo[],
    idSegmentacion: number
  ): Observable<Respuesta> {
    return this.http
      .post<Respuesta>(
        this.createSuscripcionUrl,
        { selectedNodosArbolTmm, idSegmentacion },
        this.options
      )
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(
            `POST -> getArbolSegmentosPorNodosTmm`
          )
        )
      );
  }

  getSuscripciones(): Observable<Respuesta> {
    return this.http
      .get<Respuesta>(this.getSuscripcionesUrl, this.options)
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(`GET -> getSuscripciones`)
        )
      );
  }

  getPlantillasDivModel(): Observable<Respuesta> {
    return this.http
      .get<Respuesta>(this.getPlantillasDivModelUrl, this.options)
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(
            `GET -> getPlantillasDivModel`
          )
        )
      );
  }

  getPlantillasDivModelSinCuerpo(): Observable<Respuesta> {
    return this.http
      .get<Respuesta>(this.getPlantillasDivModelSinCuerpoUrl, this.options)
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(
            `GET -> getPlantillasDivModelSinCuerpo`
          )
        )
      );
  }

  createSuscripcion(suscripcionSelected: Suscripcion): Observable<Respuesta> {
    return this.http
      .post<Respuesta>(
        this.createSuscripcionUrl,
        { suscripcionSelected },
        this.options
      )
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(`POST -> createSuscripcion`)
        )
      );
  }

  guardarSuscripcion(suscripcionSelected: Suscripcion): Observable<Respuesta> {
    let options = { headers: this.headers, withCredentials: true };
    return this.http
      .post<Respuesta>(
        this.editSuscripcionUrl,
        { suscripcionSelected },
        options
      )
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(`guardarSuscripcion`)
        )
      );
  }

  deleteSuscripcion(idSuscripcion: number): Observable<Respuesta> {
    return this.http
      .post<Respuesta>(
        this.deleteSuscripcionUrl,
        { idSuscripcion },
        this.options
      )
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(`POST -> deleteSuscripcion`)
        )
      );
  }

  activarSuscripcion(idSuscripcion: number): Observable<Respuesta> {
    return this.http
      .post<Respuesta>(
        this.activarSuscripcionUrl,
        { idSuscripcion },
        this.options
      )
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(`POST -> activarSuscripcion`)
        )
      );
  }

  getTiposInformacion(): Observable<Respuesta> {
    return this.http
      .get<Respuesta>(this.getTiposInformacionUrl, this.options)
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(`GET -> getTiposInformacion`)
        )
      );
  }

  getFullSegmentacionPorNodosSeleccionados(
    idSegmentacion: number,
    nodosSeleccionados: TmmvNodo[]
  ): Observable<Respuesta> {
    return this.http
      .post<Respuesta>(
        this.getFullSegmentacionPorNodosSeleccionadosUrl,
        { idSegmentacion, nodosSeleccionados },
        this.options
      )
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(
            `POST -> getFullSegmentacionPorNodosSeleccionados`
          )
        )
      );
  }

  getFullSegmentacion(idSegmentacion: number): Observable<Respuesta> {
    return this.http
      .post<Respuesta>(
        this.getFullSegmentacionUrl,
        { idSegmentacion },
        this.options
      )
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(
            `POST -> getFullSegmentacion`
          )
        )
      );
  }

  getFrecuencias(): Observable<Respuesta> {
    return this.http
      .get<Respuesta>(this.getFrecuenciasUrl, this.options)
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(`GET -> getFrecuencias`)
        )
      );
  }

  getMercados(): Observable<Respuesta> {
    return this.http
      .get<Respuesta>(this.getMercadosUrl, this.options)
      .pipe(
        catchError(
          this.errorService.handleError<Respuesta>(`GET -> getMercados`)
        )
      );
  }

  ////////////////////////////////////////////////

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<Respuesta> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(new Respuesta());
    };
  }
}
